//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from "lodash";
import mediaSubNav from "~/components/media-sub-nav";
import infiniteSlider5 from "~/components/infinite-slider-5";
import mediaMobileNav from "~/components/media-mobile-nav";
import VideoGallary1 from "~/components/video-gallary-1";
import SocialWall from "~/components/social-wall";
import { KinesisContainer, KinesisElement } from "vue-kinesis";
import mediaSliderMobile from "~/components/media-slider-mobile";
import YtVideoSlider from "~/components/yt-video-slider";
import mediaPlaceholder from "~/components/loading-placeholders/media-pl.vue";
import infiniteSliderPlaceholder from "~/components/loading-placeholders/infiniteSlider-pl.vue";

export default {
  data() {
    return {
      searchedData: [],
      combinedArr: null,
      searchQuery: "",
      //   form: {
      //     filter1: null,
      //   },
      //   filters1: [{ text: "Filter", value: null }, "A", "B", "C", "D"],
    };
  },
  async asyncData({ store }) {
    await store.dispatch("media/getMedia");
    const seo = store.state["media"].mediaPage.seo;
    return { seo };
  },
  head() {
    return {
      title: this.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.seo.prevent_indexing,
        },
      ],
    };
  },
  mounted() {
    // this.$store.commit("CLEAR_NEWS_RESULT");
    // this.$store.commit("CLEAR_EVENTS_RESULT");
    // this.$store.commit("media/CLEAR_INPRESS_RESULTS");
    // this.$store.commit("media/CLEAR_AUDIO_LISTENING");
    // this.$store.commit("media/CLEAR_VIDEO_LISTENING");
    // this.$store.commit("media/CLEAR_IMAGE_ALBUMS_RESULTS");
    this.$router.push({ path: "/media" });

    this.$store.dispatch("getNews", {
      page: 1,
      size: 10,
      year: "",
      month: "",
      subCategory: "",
    });
    this.$store.dispatch("getEvents", {
      page: 1,
      size: 10,
      year: "",
      month: "",
    });
    this.$store.dispatch("media/getDilmahInPress", {
      page: 1,
      size: 10,
      year: "",
      month: "",
      category: "",
      subCategory: "",
    });
    this.$store.dispatch("getImages", { page: 1, size: 50 });
    this.$store.dispatch("getAudios", { page: 1, size: 50, category: "" });
    this.$store.dispatch("tea-blog/getTeaBlog");
  },
  components: {
    infiniteSlider5,
    VideoGallary1,
    SocialWall,
    mediaMobileNav,
    KinesisContainer,
    KinesisElement,
    mediaSliderMobile,
    YtVideoSlider,
    mediaPlaceholder,
    mediaSubNav,
    infiniteSliderPlaceholder,
  },
  computed: {
    teaBlogInfoData() {
      if (this.$store.state["tea-blog"].teaBlog != null) {
        if (this.$store.state["tea-blog"].teaBlog[0] != null) {
          return this.$store.state["tea-blog"].teaBlog[0].page;
        }
      }
    },
    newsInfoData() {
      if (this.$store.state.news != null) {
        return this.$store.state.news.data;
      }
    },
    eventInfoData() {
      if (this.$store.state.events != null) {
        return this.$store.state.events.data;
      }
    },
    dilmahInPressInfoData() {
      if (this.$store.state["media"].dilmahInPress != null) {
        return this.$store.state["media"].dilmahInPress.data;
      }
    },
    imagesInfoData() {
      if (this.$store.state.images != null) {
        return this.$store.state.images.data;
      }
    },
    audioInfoData() {
      if (this.$store.state.audios != null) {
        return this.$store.state.audios.data;
      }
    },
    audioInfo() {
      if (this.audioInfoData != null) {
        return this.audioInfoData.map((audio) => ({
          thumbnail: audio.cover_image,
          name: audio.name,
          short_description: audio.short_description,
          date: audio.created_date.replaceAll("-", "/"),
          coverTitle: "Audios",
          link_folder: "media/audios",
          images: false,
          events: false,
          audio: true,
          file_size: audio.audio_file,
        }));
      }
    },
    teaBlogInfo() {
      if (this.$store.state["tea-blog"].teaBlog != null) {
        return this.teaBlogInfoData.dilmah_tea_blogs.map((blog) => ({
          thumbnail: blog.image_url,
          name: blog.header.text_en,
          short_description: blog.short_description.text_en,
          date: blog.date.replaceAll("-", "/"),
          coverTitle: "Tea Blog",
          link_folder: "media/dilmah-tea-blog",
          hash: blog.id,
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
    newsInfo() {
      if (this.$store.state.news != null) {
        return this.newsInfoData.map((newsItem) => ({
          thumbnail: newsItem.thumbnail,
          name: newsItem.name,
          short_description: newsItem.description,
          date: newsItem.news_date.replaceAll("-", "/"),
          coverTitle: "Latest News",
          link_folder: "media/news",
          hash: newsItem.name.split(" ").join("_"),
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
    eventInfo() {
      if (this.eventInfoData != null) {
        return this.eventInfoData.map((eventItem) => ({
          thumbnail: eventItem.thumbnail,
          name: eventItem.name,
          short_description: eventItem.short_description,
          date: eventItem.start_date.replaceAll("-", "/"),
          coverTitle: "Events",
          link_folder: "media/events",
          start_time: eventItem.start_time,
          end_time: eventItem.end_time,
          venue: eventItem.venue,
          hash: eventItem.name.split(" ").join("_"),
          images: false,
          events: true,
          audio: false,
        }));
      }
    },
    dilmahInPressInfo() {
      if (this.dilmahInPressInfoData != null) {
        return this.dilmahInPressInfoData.map((inPressItem) => ({
          thumbnail: inPressItem.thumbnail,
          name: inPressItem.name,
          short_description: inPressItem.short_description,
          date: inPressItem.date.replaceAll("-", "/"),
          coverTitle: "Dilmah In Press",
          link_folder: "media/dilmah-in-press",
          hash: inPressItem.name.split(" ").join("_"),
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
    imagesInfo() {
      if (this.imagesInfoData != null) {
        return this.imagesInfoData.map((image) => ({
          thumbnail: image.cover_image,
          name: image.name,
          sub_category: image.sub_category,
          link_folder: "media/images",
          hash: image.name.split(" ").join("_"),
          images: true,
          events: false,
          audio: false,
        }));
      }
    },
    getLatestArray() {
      let eventsArray = [];
      let newsArray = [];
      let dilmahInPressArray = [];
      let teaBlogArray = [];

      eventsArray.push(
        this.eventInfo
          .sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
          .slice(0, 1)
      );
      newsArray.push(
        this.newsInfo
          .sort((a, b) => new Date(b.news_date) - new Date(a.news_date))
          .slice(0, 1)
      );
      dilmahInPressArray.push(
        this.dilmahInPressInfo
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 1)
      );
      teaBlogArray.push(
        this.teaBlogInfo
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 1)
      );

      this.combinedArr = eventsArray.concat(
        newsArray,
        dilmahInPressArray,
        teaBlogArray
      );
      return this.combinedArr;
    },
    filteredItems() {
      if (this.$store.state.filteredMediaSearch != null) {
        return this.$store.state.filteredMediaSearch;
      }
    },
    eventfiltered() {
      if (this.filteredItems != null) {
        return this.filteredItems.events.map((eventItem) => ({
          thumbnail: eventItem.cover_images[0],
          name: eventItem.title,
          short_description: eventItem.description,
          date: eventItem.date.replaceAll("-", "/"),
          coverTitle: "Events",
          link_folder: "media/events",
          start_time: eventItem.start_time,
          end_time: eventItem.end_time,
          venue: eventItem.venue,
          hash: eventItem.hash,
          images: false,
          events: true,
          audio: false,
        }));
      }
    },
    newsFiltered() {
      if (this.filteredItems != null) {
        return this.filteredItems.news.map((newsItem) => ({
          thumbnail: newsItem.cover_images[0],
          name: newsItem.title,
          short_description: newsItem.description,
          date: newsItem.date.replaceAll("-", "/"),
          coverTitle: "Latest News",
          link_folder: "media/news",
          hash: newsItem.hash,
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
    audiosFiltered() {
      if (this.filteredItems != null) {
        return this.filteredItems.audios.map((audio) => ({
          thumbnail: audio.cover_image,
          name: audio.title,
          short_description: audio.description,
          date: audio.date.replaceAll("-", "/"),
          coverTitle: "Audios",
          link_folder: "media/audios",
          images: false,
          events: false,
          audio: true,
          file_size: audio.audio_file,
        }));
      }
    },
    teaBlogFiltered() {
      if (this.filteredItems != null) {
        return this.filteredItems.dilmahInPress.map((blog) => ({
          thumbnail: blog.cover_images[0],
          name: blog.title,
          short_description: blog.description,
          date: blog.date.replaceAll("-", "/"),
          coverTitle: "Tea Blog",
          link_folder: "media/dilmah-tea-blog",
          hash: blog.hash,
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
    filteredDilmahInPress() {
      if (this.filteredItems != null) {
        return this.filteredItems.dilmahInPress.map((inPressItem) => ({
          thumbnail: inPressItem.cover_images[0],
          name: inPressItem.title,
          short_description: inPressItem.description,
          date: inPressItem.date.replaceAll("-", "/"),
          coverTitle: "Dilmah In Press",
          link_folder: "media/dilmah-in-press",
          hash: inPressItem.hash,
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
    imagesFiltered() {
      if (this.filteredItems != null) {
        return this.filteredItems.images.map((image) => ({
          thumbnail: image.images[0].fileUrl,
          name: image.title,
          sub_category: image.sub_category,
          link_folder: "media/images",
          hash: image.hash,
          images: true,
          events: false,
          audio: false,
        }));
      }
    },
    videosFiltered() {
      if (this.filteredItems != null) {
        return this.filteredItems.videos.map((video) => ({
          thumbnail: video.video_cover,
          name: video.title,
          short_description: video.description,
          date: video.date != null ? video.date.replaceAll("-", "/") : "",
          link_folder: "media/videos",
          hash: video.hash,
          coverTitle: "Videos",
          images: false,
          events: false,
          audio: false,
        }));
      }
    },
  },
  watch: {
    $route() {
      if (this.searchQuery == "") {
        this.$router.push({ path: "/media" });
      }
    },
    combinedArr: function (newVal, oldVal) {
      if (newVal) {
        this.$nuxt.$loading.finish();
      }
    },
    searchQuery: function (newVal, oldVal) {
      this.$store.commit("CLEAR_FILTERED_MEDIA_SEARCH");
      this.currentPage = 1;
      let data = {
        searchedText: newVal.toLowerCase(),
      };
      this.fetchFilteredItems(data);
    },
  },
  methods: {
    // truncate(str, no_words) {
    //   if (str && no_words != "") {
    //     if (
    //       str
    //         .replace(/(^\s*)|(\s*$)/gi, "")
    //         .replace(/[ ]{2,}/gi, " ")
    //         .replace(/\n /, "\n")
    //         .split(" ").length > no_words
    //     ) {
    //       return str.split(" ").splice(0, no_words).join(" ") + "...";
    //     } else {
    //       return str;
    //     }
    //   }
    // },
    fetchFilteredItems(data) {
      this.$store.dispatch("mediaFilterSearch", data);
      this.$router.push({
        path: "/media/",
        query: data,
      });
    },
  },
};
